import { css } from "@emotion/react";

export const RTLIconStyles = (isRtl) => css`
  transform: rotate(${isRtl ? "180deg" : "0deg"});
`;
